"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function CommonProblems() {
  const { t } = useLanguage();

  const cards = [
    { titleKey: "sliding.problem1Title", descKey: "sliding.problem1Desc" },
    { titleKey: "sliding.problem2Title", descKey: "sliding.problem2Desc" },
    { titleKey: "sliding.problem3Title", descKey: "sliding.problem3Desc" },
    { titleKey: "sliding.problem4Title", descKey: "sliding.problem4Desc" },
    { titleKey: "sliding.problem5Title", descKey: "sliding.problem5Desc" },
    { titleKey: "sliding.problem6Title", descKey: "sliding.problem6Desc" },
  ];

  return (
    <section className="bg-white py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-[32px] font-bold text-[#064e3b] text-center mb-3">
          {t("sliding.servicesH2")}
        </h2>
        <p className="text-gray-600 text-center max-w-[720px] mx-auto mb-12 text-base">
          {t("sliding.problemsSubhead")}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((c) => (
            <div
              key={c.titleKey}
              className="bg-white rounded-xl border-t-4 border-[#047857] p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <h3 className="text-lg font-bold text-[#064e3b] mb-2">{t(c.titleKey)}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t(c.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}